import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "composer/Localization.jsx"
import Helper from "composer/Helper.jsx"

import {
  Icon,
  IconButton,
  Tooltip,
  Slider,
} from '@material-ui/core';

class MoviePlayerHolder extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      isPlaying: false,
      is360View: false,
      isSeeking: false,
    };
    autoBind(this);
  }

  componentDidMount() {
    let divHeight = this.refs.div.getBoundingClientRect().height;
    this.props.parent.props.parent.setState({
      moviePlayerHolderHeight: divHeight,
    });
    this.props.parent.props.parent.state.moviePlayerHolderHeight = divHeight;
  }

  sliderValueChanged = (event, value) => {
    this.props.parent.updatePlaybackTime(value);
    this.props.parent.seekVideoPlayback();
  }

  sliderDragStart() {
    this.setState({
      isSeeking: true,
    });
    this.state.isSeeking = true;
  }

  sliderDragEnd() {
    this.setState({
      isSeeking: false,
    });
    this.state.isSeeking = false;

    this.props.parent.seekVideoPlayback();
  }

  playbackClicked() {
    let playing  = !this.state.isPlaying;
    this.setState({
      isPlaying: playing,
    });
    this.state.isPlaying = playing;

    this.props.parent.refs.stageMediaMovie.forceUpdate();
  }

  switchViewClicked() {
    let view = !this.state.is360View;
    this.setState({
      is360View: view,
      isPlaying: false,
    });
    this.state.is360View = view;
    this.state.isPlaying = false;

    this.props.parent.state.playbackTime = 0;
    this.props.parent.refs.stageMediaMovie.forceUpdate();
  }

  newStageElementClicked() {
    // console.log(this.props.parent.props.parent.props.parent);
    this.props.parent.props.parent.props.parent.addStageElement();
  }

  stageHasFile() {
    let result = false;
    if (this.props.parent.props.parent.props.parent.state.selectedStage != null) {
      if (this.props.parent.props.parent.props.parent.state.selectedStage['movie_list'].length > 0) {
        result = true;
      }
    }
    return result;
  }

  render() {
    return (
      <div style={{display:'flex'}} ref="div">
        <div>
          {/* {Helper.fToHHMMSS(this.props.parent.state.playbackTime)} / {Helper.fToHHMMSS(this.props.parent.state.playbackDuration)} */}
          <Tooltip title={this.state.is360View? Localization.strings.FLAT_VIEW : Localization.strings.VIEW_360}>
            <IconButton onClick={this.switchViewClicked}>
              <Icon fontSize="small">{this.state.is360View? "crop_landscape" : "360"}</Icon>
            </IconButton>
          </Tooltip>
          <Tooltip title={this.state.isPlaying? Localization.strings.PAUSE : Localization.strings.PLAY}>
            <span>
              <IconButton onClick={this.playbackClicked} disabled={this.state.is360View}>
                <Icon fontSize="small">{this.state.isPlaying? "pause" : "play_arrow"}</Icon>
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={Localization.strings.NEW_STAGE_ELEMENT}>
            <IconButton onClick={this.newStageElementClicked} disabled={!this.stageHasFile()}>
              <Icon>add</Icon>
            </IconButton>
          </Tooltip>
          {Helper.fToHHMMSS(this.props.parent.state.playbackTime)} / {Helper.fToHHMMSS(this.props.parent.state.playbackDuration)}
        </div>
        <div style={{flex: 1, padding:'9px 18px', margin:'auto'}}>
          <Slider
            disabled={this.state.is360View}
            value={this.props.parent.state.playbackTime}
            min={0}
            max={parseInt(this.props.parent.state.playbackDuration)}
            step={1}
            onChange={this.sliderValueChanged}
            onDragStart={this.sliderDragStart}
            onChangeCommitted={this.sliderDragEnd}
          />
        </div>
      </div>
    )
  }
}

export default MoviePlayerHolder;
